import { Component, OnInit, Input, Output } from '@angular/core';
import {
  Router,
  Routes
} from '@angular/router';

import { Artikel } from '../models/artikel.model';

@Component({
  selector: 'sws-artikelliste',
  templateUrl: './artikelliste.component.html',
  styleUrls: ['./artikelliste.component.css']
})
export class ArtikellisteComponent implements OnInit {

/**
   * @input gefundeneArtikel - die Artikel[] - Liste die übergeben wurde
 */
  @Input() gefundeneArtikel: Artikel[];


  /**
   * @property currentProduct - local state containing
   *             the currently selected `Product`
   */
  private currentProduct: Artikel;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  // markierter Artikel in der Liste --------------------------------------------
  clicked(produkt: Artikel): void {
    console.log("Auf Artikel geklickt: " + produkt.ATArtikelnummer);
    this.currentProduct = produkt;
    this.router.navigate( ['/details', produkt.ATArtikelnummer] );
  }

 isSelected(product: Artikel): boolean {
    if (!product || !this.currentProduct) {
      return false;
    }
    return product.ATArtikelnummer === this.currentProduct.ATArtikelnummer;
  } 
 
  // Druck der angezeigten Artikelliste mit Beständen ----------------------------
 print(): void {
       let printContents, popupWin;
       printContents = document.getElementById('druckSection').innerHTML;
       popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
       popupWin.document.open();
       popupWin.document.write(`
          <html>
              <head>
                  <title>Liste Lagerbestand Seidler</title>
                  <style>
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
       );
       popupWin.document.close();   
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/artikelliste/artikelliste.component.ts